// AutoReplaceBye.js
import { Extension } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

export const DynDataExtension = (dataList) => {
  let currentDynDatas = dataList;
  return Extension.create({
    name: 'highlightData',

    addOptions() {
      return {
        getList: () => currentDynDatas,
        setList: (newList) => {
          currentDynDatas = newList;
        },
      };
    },
    addProseMirrorPlugins() {
      return [
        new Plugin({
          props: {
            decorations(state) {
              const decorations = [];
              const { doc } = state;
              const regex = /(\{\{[a-zA-Z]+\}\})/g;

              doc.descendants((node, pos) => {
                if (!node.isText) return;
                let match;
                let isData;
                while ((match = regex.exec(node.text))) {
                  isData = currentDynDatas.some(
                    ({ label }) => `{{${label}}}` === match[1]
                  );
                  if (isData) {
                    const start = pos + match.index;
                    const end = start + match[1].length;
                    decorations.push(
                      Decoration.inline(start, end, {
                        class: 'editor-text-highlight',
                      })
                    );
                  }
                }
              });

              return DecorationSet.create(doc, decorations);
            },
          },
        }),
      ];
    },
  });
};
